"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import Flash from "@/components/flash";
import { flashContext } from "@/context/flash-context";
import { flashPathType } from "@/TS/Types/global_types";
function ClientFlash(t0) {
  const $ = _c(8);
  const {
    path,
    className
  } = t0;
  const {
    flashContextValue
  } = useContext(flashContext);
  let t1;
  if ($[0] !== className || $[1] !== flashContextValue.message || $[2] !== flashContextValue.position || $[3] !== flashContextValue.type || $[4] !== path) {
    t1 = flashContextValue.message && (flashContextValue.position === path || flashContextValue.position === "global") && <Flash type={flashContextValue.type} className={className}>{flashContextValue.message}</Flash>;
    $[0] = className;
    $[1] = flashContextValue.message;
    $[2] = flashContextValue.position;
    $[3] = flashContextValue.type;
    $[4] = path;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <>{t1}</>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export default ClientFlash;